import React from 'react'
import { Form, Field } from 'react-final-form'
import { injectIntl } from 'react-intl'
import { Button } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { connect } from 'react-redux'
import Input from 'components/common/Form/Input'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import messages from './translate'

function SensorTypeForm(props) {
  const {
    onSubmit,
    formData: { translations },
    intl: { formatMessage },
  } = props

  return (
    <Paper className="licensee-paper">
      <Grid container spacing={1}>
        <Grid item container xs={12} sm={12}>
          <Form
            onSubmit={onSubmit}
            render={({ handleSubmit, submitting, pristine }) => (
              <form
                onSubmit={handleSubmit}
                className="form-basic licensee-form">
                {translations.map(({ type_name, locale }) => (
                  <Grid key={`${type_name}_${locale}`}>
                    <h6>{locale.toUpperCase()}</h6>
                    <Field
                      name={`${locale}[type_name]`}
                      type="text"
                      label={`${locale} ${formatMessage(messages.title)}`}
                      component={Input}
                      className="form-control"
                      defaultValue={type_name}
                      disabled={submitting}
                      required={locale === 'en'}
                      validate={
                        locale === 'en'
                          ? getValidator(VALIDATOR_IS_EMPTY)
                          : null
                      }
                    />
                  </Grid>
                ))}
                <div className="form-group buttons">
                  <Button
                    href={null}
                    type="submit"
                    color="primary"
                    size="medium"
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={submitting || pristine}>
                    {formatMessage(messages.saveInfo)}
                  </Button>
                </div>
              </form>
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

export default connect(
  state => ({
    loading: state.getIn(['sensorTypeTranslations', 'loading']),
  }),
  {},
)(injectIntl(SensorTypeForm))
